<script>
  import {External, M} from "../../external";
  import {SMS, WHATSAPP, VOICE} from "../static";

  export let data, next;

  if (!data.data) {
    data.data = {};
  }
  if (!data.content) {
   data.content = {}; //the message object used by the MessagingService
  }
  if (!data.type) {
    data.type = SMS;                                          //used by the CampaignsController
    data.content.channel = External.CRM_MESSAGE_CHANNEL.SMS;  //used by the MessagingService
  }

  let onNext = () => {
    next();
  };

  let setType = (campaignType, messageChannel) => {
    data.type = campaignType;
    data.content.channel = messageChannel;
  }

</script>

<div class="flex-1 overflow account-settings store-products">
  <div class="col20 f-left">
    <div class="top-background-wrapper wide-top-background">
      <div class="top-background" style="max-width: 850px;">
        <div class="text-wrapper"></div>
      </div>
    </div>
    <div class="content-wrapper horizontal-flex-table" style="max-width: 850px; margin-top: 100px;" data-role="table-content">
      <div class="sections-wrapper members-wrapper horizontal-flex-table">
        <div class="section-bg members-wrapper products-wrapper crm-table-outer" style="box-shadow: none; padding: 0;">
          <div class="system-emails-wrapper">
            <div class="col20 f-left t-center mb-15"><span class="material-icons-outlined fingerprint-icon" style="font-size: 26px;"> border_all </span></div>
            <h2 class="col20 f-left t-center" style="font-size: 26px;">{M.CAMPAIGN_TYPE}</h2>
            <div class="col20 f-left email-section-description t-center mt-10 mb-25">{M.CAMPAIGN_TYPE_PICK}</div>
            <div class="col20 flex f-left t-center justify-center">
              <a class="addon-select third-select" class:selected={data.type === SMS} on:click={() => setType(SMS, External.CRM_MESSAGE_CHANNEL.SMS)} style="max-width: 300px;">
                <img alt="" class="mt-15" src="{External.resources + '/images/sms-campaign.png'}" />
                <h4 class="col20 f-left mt-25">{M.SMS_CAMPAIGN}</h4>
                <span class="col20 f-left t-center light-gray-text">{M.SMS_CAMPAIGN_DESC}</span>
              </a>
              <a class="addon-select third-select" class:selected={data.type === WHATSAPP} on:click={() => setType(WHATSAPP, External.CRM_MESSAGE_CHANNEL.WHATSAPP)} style="max-width: 300px;">
                <img alt class="mt-15" src="{External.resources + '/images/whatsapp-campaign.png'}" />
                <h4 class="col20 f-left mt-25">{M.WHATSAPP_CAMPAIGN}</h4>
                <span class="col20 f-left t-center light-gray-text">{M.WHATSAPP_CAMPAIGN_DESC}</span>
              </a>
              <a class="addon-select third-select" class:selected={data.type === VOICE} on:click={() => setType(VOICE, External.CRM_MESSAGE_CHANNEL.VOICE)} style="max-width: 300px;">
                <img alt class="mt-15" src="{External.resources + '/images/voice-campaign.png'}" />
                <h4 class="col20 f-left mt-25">{M.VOICE_CAMPAIGN}</h4>
                <span class="col20 f-left t-center light-gray-text">{M.VOICE_CAMPAIGN_DESC}</span>
              </a>
            </div>
            <div class="col20 f-left flex justify-center mt-35 mb-35">
              <a data-action="nextPage" on:click={onNext} class="big-button blue circle-effect transition-bg f-left" style="margin-left:5px;">{M.NEXT} →</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
